import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Contact, ContactCreate, ContactFilter } from '../data/contact';

export function createContactService(client: AxiosInstance) {
  return createCrudService<Contact, ContactCreate, ContactFilter>(
    client,
    '/master-data/Contact',
    'id',
  );
}

export type ContactService = CrudService<Contact, ContactCreate, ContactFilter>;
